/** `YYYY-MM-DD` for HTML date inputs (local calendar). */
export function formatDateToInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** First and last day of the calendar month containing `reference` (defaults to today). */
export function getCalendarMonthInputRange(reference: Date = new Date()): {
  dateFrom: string;
  dateTo: string;
} {
  const start = new Date(reference.getFullYear(), reference.getMonth(), 1);
  const end = new Date(reference.getFullYear(), reference.getMonth() + 1, 0);
  return { dateFrom: formatDateToInputValue(start), dateTo: formatDateToInputValue(end) };
}

export function formatDateToDisplay(value?: string | Date | null): string {
  if (!value) {
    return '';
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function parseDisplayDateToIso(value?: string | null): string | undefined {
  if (!value?.trim()) {
    return undefined;
  }

  const trimmed = value.trim();
  const displayMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (displayMatch) {
    const [, day, month, year] = displayMatch;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    return trimmed;
  }

  return undefined;
}

export function getLastDayOfMonthDisplay(reference?: string | Date | null): string {
  let ref: Date;
  if (reference instanceof Date) {
    ref = reference;
  } else if (typeof reference === 'string' && reference.trim()) {
    const iso = parseDisplayDateToIso(reference);
    ref = iso ? new Date(`${iso}T00:00:00`) : new Date();
  } else {
    ref = new Date();
  }

  if (Number.isNaN(ref.getTime())) {
    ref = new Date();
  }

  const lastDay = new Date(ref.getFullYear(), ref.getMonth() + 1, 0);
  return formatDateToDisplay(lastDay);
}

/** Parking expiry: 00:00 on the 1st of the next month (matches Excel / Quản lý xe tháng). */
export function getFirstDayOfNextMonthDisplay(reference?: string | Date | null): string {
  let ref: Date;
  if (reference instanceof Date) {
    ref = reference;
  } else if (typeof reference === 'string' && reference.trim()) {
    const iso = parseDisplayDateToIso(reference);
    ref = iso ? new Date(`${iso}T00:00:00`) : new Date();
  } else {
    ref = new Date();
  }

  if (Number.isNaN(ref.getTime())) {
    ref = new Date();
  }

  const firstOfNextMonth = new Date(ref.getFullYear(), ref.getMonth() + 1, 1);
  return formatDateToDisplay(firstOfNextMonth);
}
